export const regularTabelData = [
    {
        firstname: "Alice",
        lastname: "Blue",
        email: "aliceblue@gmail.com",
        phonenumber: "9837627262",
        role: "Developer"
    },
    {
        firstname: "Aaron",
        lastname: "Hank",
        email: "aaronhank@gmail.com",
        phonenumber: "3532523523",
        role: "Business"
    },
    {
        firstname: "Abagnale",
        lastname: "Frank",
        email: "abagnalefrank@gmail.com",
        phonenumber: "4575444444",
        role: "Worker"
    },
    {
        firstname: "Babbitt",
        lastname: "Milton",
        email: "babbittmilton@gmail.com",
        phonenumber: "6575566778",
        role: "Developer"
    },
    {
        firstname: "Desmond",
        lastname: "Paul",
        email: "DesmondPaul@gmail.com",
        phonenumber: "7864332244",
        role: "Engineeer"
    },
    {
        firstname: "Everett",
        lastname: "Carl",
        email: "EverettCarl@gmail.com",
        phonenumber: "9837627262",
        role: "Developer"
    }
];

export const regularTabelColumns = [
    {
        column: "FirstName",
        index: "firstname"
    },
    {
        column: "LastName",
        index: "lastname"
    },
    {
        column: "Email",
        index: "email"
    },
    {
        column: "PhoneNumber",
        index: "phonenumber"
    },
    {
        column: "Role",
        index: "role"
    }
];

export const regularTablesList = [
    {
        title: "Simple Table",
        caption: "",
        dark: false,
        headerDark: false,
        striped: false,
        bordered: false,
        borderless: false,
        hover: false,
        small: false
    },
    {
        title: "Striped rows",
        caption: "",
        dark: false,
        headerDark: false,
        striped: true,
        bordered: false,
        borderless: false,
        hover: false,
        small: false
    },
    {
        title: "Table head Dark",
        caption: "",
        dark: false,
        headerDark: true,
        striped: true,
        bordered: false,
        borderless: false,
        hover: false,
        small: false
    },
    {
        title: "Bordered table",
        caption: "",
        dark: false,
        headerDark: false,
        striped: false,
        bordered: true,
        borderless: false,
        hover: false,
        small: false
    },
    {
        title: "Borderless table",
        caption: "",
        dark: false,
        headerDark: true,
        striped: false,
        bordered: false,
        borderless: true,
        hover: false,
        small: false
    },
    {
        title: "Hoverable rows",
        caption: "",
        dark: false,
        headerDark: false,
        striped: false,
        bordered: false,
        borderless: false,
        hover: true,
        small: false
    },
    {
        title: "Small table",
        caption: "",
        dark: false,
        headerDark: false,
        striped: false,
        bordered: false,
        borderless: false,
        hover: true,
        small: true
    },
    {
        title: "Dark Table",
        caption: "User List",
        dark: true,
        headerDark: false,
        striped: true,
        bordered: true,
        borderless: false,
        hover: false,
        small: false
    }
];
